import { Component, OnInit } from '@angular/core';
import { BoardOfTrustees } from '../../models/board-of-trustees';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-get-board-of-trustee-details',
  templateUrl: './get-board-of-trustee-details.component.html',
  styleUrls: ['./get-board-of-trustee-details.component.scss'],
})
export class GetBoardOfTrusteeDetailsComponent implements OnInit {
  model = {} as BoardOfTrustees;
  constructor(
    private route: Router,
    private diag: NbDialogRef<GetBoardOfTrusteeDetailsComponent>,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  close() {
    this.diag.close();
  }
}
